/* istanbul ignore file */
import { READ_CANDIDATE_NOTES_PERMISSION } from 'domain/recruiting/candidate/Timeline/note/note/candidateNoteService';
import { HtmlField } from 'framework/ui/field';
import CandidateNoteTag from 'domain/recruiting/candidate/Timeline/note/shared/NoteTimelineRecordLayout/CandidateNoteTag';
import BasePersonTimelineRecordLayout from 'domain/shared/timeline/person/PersonTimelineRecord/BasePersonTimelineRecordLayout';
import { TimelineCollapsible } from 'framework/ui/timeline';
import { CANDIDATE_TIMELINE_ICONS, CANDIDATE_TIMELINE_MESSAGE_CONTEXT } from 'domain/shared/candidate';
import { Box } from '@mui/material';
import { feedbackTimelineFooterSx } from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/baseTimelineRecordSx';

type NoteTimelineRecordLayoutProps = {
  actionName: string;
};

const SystemNoteTimelineRecordLayout = ({ actionName, ...props }: NoteTimelineRecordLayoutProps) => {
  return (
    <BasePersonTimelineRecordLayout
      permissionToCheck={READ_CANDIDATE_NOTES_PERMISSION}
      actionName={actionName}
      buttons={[]}
      timelineType="SystemNote"
      timelineIcons={CANDIDATE_TIMELINE_ICONS}
      messageContext={CANDIDATE_TIMELINE_MESSAGE_CONTEXT}
      fields={
        <TimelineCollapsible>
          <HtmlField source="noteText" label="" />
        </TimelineCollapsible>
      }
      timelineFooter={rest => (
        <Box sx={feedbackTimelineFooterSx}>
          <CandidateNoteTag {...rest} />
        </Box>
      )}
      {...props}
    />
  );
};

export default SystemNoteTimelineRecordLayout;
